// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__d41h4","header":"Messages_header__2Mhqi"};